import { GoToHelpCenterCTA } from "./ctas";
import { CONTACT_US_IF_FURTHER_HELP } from "./shared";
export var OnboardingHowFaireWorksIA = function OnboardingHowFaireWorksIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return HOW_FAIRE_WORKS_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [HOW_FAIRE_WORKS_DESCRIPTION(strictLocalize), CONTACT_US_IF_FURTHER_HELP(strictLocalize)];
    }
  };
};
var HOW_FAIRE_WORKS_TITLE = function HOW_FAIRE_WORKS_TITLE(strictLocalize) {
  return strictLocalize({
    id: "Wp3M8f",
    defaultMessage: [{
      "type": 0,
      "value": "Informations générales sur Faire"
    }]
  });
};
var HOW_FAIRE_WORKS_DESCRIPTION = function HOW_FAIRE_WORKS_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "e+fanp",
    defaultMessage: [{
      "type": 0,
      "value": "Vous trouverez plus d'informations sur Faire dans notre Centre d'aide."
    }]
  });
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return GoToHelpCenterCTA(strictLocalize);
};